import React from "react";

import NavBar from "../components/NavBar";
import Content from "../components/LandingContent";
import Packages from "../components/packages";
import "../App.css";

const Landing = () => {
  return (
    <div className="display-flex" id="alpha-container">
      <NavBar />
      <Content />
      <Packages />
    </div>
  );
};

export default Landing;
